import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Breadcrumb, Button, PageHeader, Spin, Tag, Table } from "antd";
import moment from "moment";
import Page from "_components/Page";
import TabMenu from "./TabMenu";
import { materialRequestService } from "_services";

function History({ history, match }) {
  const { id } = match.params;
  const { path } = match;
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [error, setError] = useState(null);
  const [materialRequest, setMaterialRequest] = useState({});

  useEffect(() => {
    const fetchAlldatas = async () => {
      setLoading(true);
      const requestData = await materialRequestService.getById(id);

      if (requestData) {
        setMaterialRequest(requestData.content);
      }
      setLoading(false);
    };

    fetchAlldatas();
    getStockHistory(id);
  }, []);

  const getStockHistory = (requestId) => {
    setLoading(true);
    materialRequestService
      .getHistory(requestId)
      .then((x) => {
        setItems(x.content);
        setLoading(false);
      })
      .catch((errorInfo) => {
        setLoading(false);
        setError(errorInfo);
      });
  };

  const onCancel = () => {
    history.push(`/material-requests/${id}/summary`);
  };

  const getActionButtons = () => {
    let buttons = [];
    buttons.push(
      <Button key="btn-cancel" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );
    return buttons;
  };

  const columns = [
    {
      title: "Event",
      dataIndex: "event",
      key: "event",
    },
    {
      title: "Event Date",
      dataIndex: "eventDate",
      key: "eventDate",
      render: (text, record) => moment(text).format("YYYY-MM-DD HH:mm"),
    },
    {
      title: "Note",
      dataIndex: "notes",
      key: "notes",
    },
    {
      title: "Employee",
      dataIndex: "employeeName",
      key: "employeeName",
    },
  ];

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/material-requests">Material Request Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`${path}`.replace(":id", id)}>
                {materialRequest.requestNumber} ::{" "}
                <Tag
                  color={`${
                    materialRequest.orderStage === "OPEN"
                      ? "#2db7f5"
                      : ["IN_PROGRESS", "ACCEPTED"].includes(
                          materialRequest.orderStage
                        )
                      ? "#108ee9"
                      : "#87d068"
                  }`}
                >
                  {materialRequest.orderStage}
                </Tag>
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>History</Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner error={error}>
          <TabMenu menu="history" id={id} status={materialRequest.orderStage} />
          <Spin tip="Loading..." spinning={loading}>
            <Table
              bordered
              rowKey="id"
              size="small"
              columns={columns}
              dataSource={items}
              pagination={false}
            />
          </Spin>
        </Page>
      </PageHeader>
    </div>
  );
}

export default History;
